import { useMediaQuery } from '@mantine/hooks'
import { useState } from 'react'

import styles from './kdt-ugm-5th.module.scss'

interface IUgmProjectTabProps {
  projectDetailList: {
    id: number
    step: string
    title: string
    desc?: string
    contents: {
      contentsImagePc: string
      contentsImageM: string
      contentsDesc: string
    }[]
  }[]
}

const UgmProjectTab = ({ projectDetailList }: IUgmProjectTabProps) => {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const [value, setValue] = useState(0)
  const selectedDetail = projectDetailList[value]

  const onClickWeek = (id: number) => {
    setValue(id)
  }

  return (
    <div className="flex w-full">
      <div className="w-[395px] shrink-0 px-8 py-10">
        <ul className={`${styles.project_accordion_dot_ul} flex flex-col gap-3`}>
          {projectDetailList.map(detail => (
            <li key={detail.id} className="flex flex-row items-center gap-8">
              <div
                className={`${
                  value === detail.id
                    ? 'border-[2px] border-yellow-450 bg-yellow-450 shadow-[0_0_10px_0_#FF7710]'
                    : 'border-[2px] border-label-alternative bg-trueGray-800'
                } z-10 h-3 w-3 rounded-full`}
              ></div>
              <div
                className={`${
                  value === detail.id
                    ? 'border border-yellow-450 bg-[rgba(255,119,16,0.10)]'
                    : 'border border-[#525252] bg-[#2E2E2E]'
                } flex flex-1 cursor-pointer flex-col gap-1 rounded px-5 py-4`}
                onClick={() => onClickWeek(detail.id)}
              >
                <p
                  className={`${
                    value === detail.id ? 'text-yellow-450' : 'text-[rgba(255,119,16,0.5)]'
                  } text-base font-bold`}
                >
                  {detail.step}
                </p>
                <h6
                  className={`${
                    value === detail.id ? 'text-white' : 'text-[rgba(255,255,255,0.5)]'
                  } whitespace-pre-line text-xl font-bold leading-snug`}
                >
                  {detail.title}
                </h6>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="flex-1 px-8 py-10">
        <div className="w-full">
          <div className="mb-8 flex flex-col gap-2">
            <h6 className="text-2xl font-bold text-white">{selectedDetail.title}</h6>
            <p className="whitespace-pre-line text-lg leading-normal text-white">
              {selectedDetail.desc}
            </p>
          </div>
          {selectedDetail.contents.map(content => (
            <div className="flex flex-col gap-8" key={content.contentsDesc}>
              <div className="relative">
                <img
                  className="relative z-10 h-full w-full object-contain"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-ugm-5th/section4_gif_deco_pc.png"
                  alt="-"
                />
                <img
                  src={content.contentsImagePc}
                  className="absolute left-0 top-0 h-full w-full object-contain"
                  loading="lazy"
                  alt={content.contentsDesc}
                />
              </div>
              <p className="text-base text-label-alternative">{content.contentsDesc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default UgmProjectTab
